import * as Polyglot from "node-polyglot"

export interface MessageProvider {
    getCurrentLang():string;
    get(key:string, params?:any, lang?:string):string;
}

let enMessages = {
    "title": "MMBusTicket",
    "lang.my": "မြန်မာ",

    "nav_title.express_bus_trips": "Express Bus Trips",
    "nav_title.small_car_trips": "Ride Share Trips",
    "nav_title.search_trip": "Search Trip",
    "nav_title.select_seat": "Select Seats",
    "nav_title.select_pickup_dropoff": "Pickup/Drop-off Details",
    "nav_title.make_payment": "Make Payment",
    "nav_title.booking_info": "Booking Info",
    "nav_title.traveller_info": "Traveller Info",
    "nav_title.terms_conditions": "Terms and Conditions",
    
    "nav_title.already_paid": "Duplicate Payment",
    
    "departure": "Departure Time",
    "price": "Price",
    "operators": "Operators",

    "day_bus": "Day Bus",
    "night_bus": "Night Bus",
    "afternoon_bus" : "Afternoon Bus",
    "price_low_high": "Low to High",
    "price_high_low": "High to Low",

    "all_filter": "Filter",
    "filter_title": "Filter & Sort",
    "cancel": "Cancel",
    "apply": "Apply",

    "operator_photo": "Photo",
    "operator_photos": "Photos",

    "location_from": "From",
    "location_to": "To",
    "departure_date": "Departure Date",
    "seat": "Seat",
    "seats": "Seats",
    "seat_number" : "Seat No : ",
    "seat_numbers" : "Seat No.",

    "about_operator": "About Operator",
    

    "tooltip": "operator and others",

    "tonight": "Tonight",
    "one": "1",
    "top_location": "Top Destinations",
    "select_destination": "Select Destination",
    "select_seats": "Select",
    "location": "Where to go?",
    "locations": "Where to go?",
    "search": "Search",
    "search_now": "Search Now",
    "search_small_car": "Search Ride Share",
    "local": "Local",
    "foreigner": "Foreigner",
    "all_photos": "Photos",
    "photo": "Photo",
    "photos": "Photos",
    "prices": "prices",
    "all_prices": "all prices",
    "lowest_prices": "Lowest to Highest",
    "highest_prices": "Highest to Lowest",
    "price_range": "price range",
    "promotion": "promotion",
    "select_price_range": "Select Price Range",
    "select_price_order_type": "Selecte Price Order Type",
    "from": "from",
    "check_out": "Check Out",
    "continue": "Continue",
    "read_more": "Read More",
    "read_less": "Read Less",
    "details": "details",
    "select": "Select",
    "view_booking_details": "View Booking Details",
    "name": "Name",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "mixed_group": "Mixed Group",
    "email": "Email",
    "phone_number": "Phone Number",
    "nationality": "Nationality",
    "myanmar": "Myanmar",
    "myanmar_nationality": "Myanmar Nationality",
    "special_request": "Special Request",
    "submit": "Submit",
    "contect_header": "Enter Your Information",
    "night": "Night",
    "secure_checkout": "Secure CheckOut",
    "sub_total": "Subtotal",
    "convience_fee": "Convience Fee",
    "total": "Total",
    "pay_now": "Pay Now",
    "payment_summary": "Payment Summary",
    "payment": "Payment",
    "contact_information": "Contact Information",
    "edit": "Edit",
    "close": "Close",
    "gallery": "Gallery",
    "warning": "Warning",
    "seat_not_availiable": "Seat is not available. Please choose another seat.",
    "failed_to_request_seat_order": "This trip is currently unavailable. Please choose another trip.",
    "seat_will_lost": "Your seat selections will be lost",
    "can't_change_seat_selection": "Cannot Change Seat Selection",
    "back_to_seat_selection_confirmation_title": "Confirm to Go Back",
    "back_to_seat_selection_confirmation_description": "Go back to view seat layout?",
    "back_to_seat_selection_confirm_and_alert_description": "Pickup/Drop-off information will be lost. Go back to seat selection?",
    "back_to_seat_selection": "Go back to seat selection?",
    "waypoint_selection_edit_confirm_message": "Go back to Pickup/Drop-off Selection Page?",
    "filled_data_will_lost": "Any information you’ve entered will be lost.",
    "restart_warning_title" : "Go Back To Initial Page",
    "restart_warning_message" : "Go back to initial search page?",
    "nrc_card_is_required": "NRC Card is required to onboard the bus.",
    "seat_selection_allowed": "Seat Selection",

    "search_form.type_express_bus": "Express Bus",
    "search_form.type_small_car": "Ride Share",
    "search_form.promotion": "Promotion",

    "feedback_driver_discipline": "Driver Behavior",
    "feedback_driver_comfort": "Seat Comfortableness",
    "feedback_driver_cleanliness": "Cleanliness",
    "feedback_driver_service": "Staff Politeness",
    "feedback_driver_punctuality": "Punctuality",
    "message.no_express_trip_available": "No 'Express Bus' trip is available.",
    "message.no_small_car_trip_available": "No 'Ride Share' trip is available.",
    "message.no_trip_available": "No trip is available.",
    "message.change_date_or_route": "Please find another date or route.",

    "seat_selection_is_not_allowed": "Seat selection is not available for this trip.",
    "seat_selection_is_auto_after_payment": "For this operator, seat selection is not available, and seats will be automatically assigned after the payment confirmation.",

    "review.title": "Verify Info",
    "review.update_traveller_info": "Update",
    "review.continue": "Continue",
    "review.ensure_info_correctness": "Ensure that all information is accurate before proceeding.",

    "review.total_due": "Total Due",
    "review.pay_now": "Pay Now",
    "review.pay_before_time": "Pay before %{time} to confirm booking",
    "review.unit_ticket_price": "Unit Price",
    "review.ticket_price": "Ticket Price",
    "review.discount": "Discount",
    "review.convenience_fee": "Convenience Fee",
    "review.tax": "Tax",
    "review.use_promo_code": "Use Promo Code",
    "review.apply_promo_code": "Apply",
    "review.applying_promo_code": "Checking...",
    "review.applied_promo_code": "Applied Promo Code",
    "review.remove_promo_code": "Remove",
    "review.invalid_promo_code": "Invalid Promo Code",

    "review.traveller_info": "Review Traveller Info",

    "operator.name": "Operator",
    "operator.photos_unavailable": "Photos are not available.",
    
    "trip.operator_notices": "Notices by %{name}",
    
    "trip.morning": "Morning",
    "trip.afternoon": "Afternoon",
    "trip.evening": "Evening",

    "trip.route": "Full Itinerary",
    "trip.route_details": "Route Details",
    "trip.operator": "Operator",
    "trip.bus_type": "Bus Type",
    "trip.departure_gate": "Departure Gate",
    "trip.departure_time": "Departure Time",
    "trip.arrival_time": "Arrival Time",
    "trip.arrival_gate": "Arrival Gate",
    "trip.eta_duration": "Estimated Duration",
    "trip.duration" : " Duration",
    "trip.eta": "ETA",
    "trip.estimated": "ETA",
    "trip.notice_estimated_arrival" : "Arrival times provided are estimates and subject to change.",

    "trip.starts_at": "%{time} (origin)", 
    "trip.departs_at": "%{time} (departure)", 
    "trip.arrives_at": "%{time} (ETA)", 

    "trip.starts": "(origin)", 
    "trip.departs": "(departure)", 
    "trip.arrives": "(ETA)", 

    
    "trip_group.departs": "departs", 

    "seat_selection.seat_unit_singular": "Seat",
    "seat_selection.seat_unit_plural": "Seats",
    "seat_selection.seat_count": "Seat Count",
    "seat_selection.seat_numbers": "Seat Numbers",

    "seat_selection.submit": "Continue",
    "seat_selection.submitting": "Wait...",

    "traveller_form.name": "Traveller Name",
    "traveller_form.gender": "Gender",
    "traveller_form.phone": "Phone Number",
    "traveller_form.phone_instruction": "The confirmation SMS will be sent to this number.",
    "traveller_form.email": "Email",
    "traveller_form.email_instruction": "The confirmation email will be sent to this email.",
    "traveller_form.special_request": "Special Request",
    "traveller_form.gender_option_male": "Male",
    "traveller_form.gender_option_female": "Female",
    "traveller_form.gender_option_mixed_group": "Mixed Group",
    "traveller_form.next_step_instruction": "You will make the payment in the next step.",

    "traveller_form.submit": "Submit",
    "traveller_form.submitting": "Submitting",

    "traveller.name": "Traveller Name",
    "traveller.phone": "Phone Number",
    "traveller.email": "Email",
    "traveller.no_fill" : "Not Filled",
    "traveller.special_request": "Special Request",    

    "booking.subtotal_amount": "Subtotal",
    "booking.ticket_price_subtotal": "Subtotal",
    "booking.ticket_price_pickup_dropoff_subtotal": "Subtotal",
    "booking.tax_amount": "Tax",
    "booking.discount_amount": "Discount",
    "booking.total_payment_amount": "Total Due",

    "booking.purchased_date": 'Booked on',

    "section.trip_summary_title": "Trip Summary",
    "section.seat_selection_title": "Seat Selection",
    "section.traveller_info_title": "Traveller Info",
    "section.due_amount_details": "Due Amount",
    "section.payment_details" : "Payment Details",

    "duration_hour": "Hours",
    "duration_minute": "Minutes",  

    "booking_confirmation_awaiting.title" : "Confirmation Progress",
    "booking_confirmation_awaiting.message_to_reload": "Click below if taking too long.",

    "confirmation.payment_successful": "Payment Successful",
    "confirmation.please_wait_booking_confirmation": "Please wait. Booking confirmation is in progress . . .",
    "confirmation.confirming_booking": "Booking Confirming . . .",
    "confirmation.please_wait": "Please wait a moment.",

    "payment_successful": "Payment Successful",
    "booking_confirmation": "Booking Confirmation in Progress ...",
    "waiting_message": "Please, wait...",
    
    "nav_menu.home": "Home",
    "nav_menu.my_bookings": "My Bookings",
    "nav_menu.find_my_booking": "Print Your Ticket",
    "nav_menu.about_us": "About Us",
    "nav_menu.terms_conditions": "Terms & Conditions",
    "nav_menu.privacy_policy": "Privacy Policy",
    "nav_menu.faq": "Frequently Asked Questions",
    "nav_menu.contact": "Contact Us",
    "nav_menu.help": "Help",

    "estimated" : "(Estimated)",
    "proceed_to_payment": "Proceed To Payment",

    "confirmation_title.back_to_initial_page": "Go Back To Initial Page",
    "confirmation_msg.back_to_initial_page": "Thank you for booking with us. Go back to initial search page?",
    "confirmation_msg.back_to_home" : "Back to Home Page",

    "search.choose_source_location" : "Choose Source Location",
    "search.choose_destination_location" : "Choose Destination Location",
    "search.confirm_cancellation": "Will be back to home page and current search will be cancelled.",

    "booking_confirmation.booking_success_msg": "Booking confirmation is successful.",
    "booking_confirmation.send_confirmation_info": "Once the assignment is completed, the confirmation will be sent to your entered email or via SMS.",
    "booking_details.booked_at" : "Booked at",

    "review_info.confirmation_header_message" : "Please double-check the trip and traveller info.",
    "review_info.confirmation_checkbox_message" : "I have reviewed the trip and the traveller info, and I agree to proceed.",
    
    "my_bookings.no_booking_message_title" : "You haven't any booking yet.",
    "my_bookings.no_booking_message_description" : "Book your ideal trip and create memories.",
    "my_bookings.booking_details": "Booking Details",
    "my_bookings.booked_at_time": "Booked at %{time}",
    "my_bookings.processint_status": "Processing",
    "my_bookings.processing_booking_date": "Booked At",
    "my_booking_details.processing_title" : "We are processing your booking to secure your selected seats.",

    "need_help" : "Need Help? ",
    "contact.call_hotline": "Customer Support", 

    "validity.traveller_name": "Traveller Name is required.",
    "validity.required_phone_number": "Phone number is required",
    "validity.invalid_phone_number": "Phone number must start with '09' and contain 9 to 11 digits.",
    "validity.email": "The email address provided is invalid.",
    "validity.required_selection" : "Please select one of these options.",

    "payment.error_title": "Payment is not successful",
    "payment.error_generic_advice": "You may try again, but please ensure your network connection is stable and that your seat selection was made within the last 10 minutes.",



    "summary" : "Summary",
    "subtotal" : "Subtotal",
    "fees" : "Convenience Fees",
    "discount": "Discount",
    "net_to_pay": "Net To Pay",
    "terms" : "Terms and Conditions",
    "agree_to_terms": "By continuing, you agree to the ",
    "terms_link": "terms and conditions",
    "agree_to_terms_end": ".",
    "proceed_to_pay" : "Proceed To Pay",
    "title_payment_method" : "Payment Method",
    "to_reselect" : "Change",
    "show_other_methods" : "Change Payment Method",
    "promo_code": "Promo Code",
    "apply_code": "Apply",
    "apply_promo_code": "Apply Promo Code",
    "message.required_promo_code": "Promo code is required.",
    "message.invalid_promo_code": "The promo code is invalid.",

    "message_title.payment_completed": "Payment Already Completed",
    "message_description.payment_completed": "This booking has been successfully paid and no additional payment can be accepted.",
    "message.help_info": "If you require assistance, please contact our support team.",
    

    "trip.multiple_price" : "Multiple Prices",
    "seat_selection.select_one_seat" : "Please select 1 seat.",
    "seat_selection.select_n_seats" : "Please select %{numOfSeats} seats.",
    "price_per_seat": "Price Per Seat",
    "common.per_seat" : "1 Seat",
    "total_seat_price": "Total Seat Price",

    "way_point_selection.number_of_travellers": "Number of Travellers",
    "way_point_selection.address": "Address",
    "way_point_selection.pickup_location": "Pickup Location",
    "way_point_selection.dropoff_location": "Drop-off Location",    
    "way_point_selection.choose_pickup_title": "Choose Pickup Location",
    "way_point_selection.choose_dropoff_title": "Choose Drop-off Location",
    "way_point_selection.choose_pickup_location": "Choose the pickup location.",
    "way_point_selection.choose_dropoff_location": "Choose the drop-off location.",    
    "way_point_selection.pickup_location_details": "Pickup Address Details",
    "way_point_selection.dropoff_location_details": "Drop-off Address Details", 
    "way_point_selection.remove": "Remove", 
    "way_point_selection.change": "Change", 
    "way_point_selection.select_for_remaining_travellers": "Select for remaining %{numOfTravellers} passenger(s).", 

    "way_point_selection.number_of_travellers_from_pickup_location": "Number of passengers boarding from the address",
    "way_point_selection.number_of_travellers_to_dropoff_location": "Number of passengers dropping off at the address",

    
    
    "way_point_selection.number_of_travellers_from_fixpoint": "Number of passengers from this gathering point",
    "way_point_selection.number_of_travellers_to_fixpoint": "Number of passengers to this gathering point",
    "common.gathering_point_description": "Description about this gathering point",

    "way_point_selection.all_travellers": "All travellers",

    "way_point_selection.single_pickup_location_selected_for_all": "Same pickup location for all.",
    "way_point_selection.single_dropoff_location_selected_for_all": "Same drop-off location for all.",
    
    "no_of_travellers" : "Number of Travellers",
    "no_of_seats" : "Number of Seats",
    "small_car.non_direct_booking_warning_": "Selected seats will be prioritized. No grantee.",
    "small_car.non_direct_booking_warning": "Selected seats will be prioritized, but positions may vary slightly.",

    
    "way_point_selection.one_person": "1 Seat",
    "way_point_selection.no_of_traveller_unit": "person",
    "way_point_selection.no_of_travellers_unit": "person(s)",
    "total_pickup_fee": "Total Pickup Fee",
    "total_dropoff_fee": "Total Drop-off Fee",
    "total_seats_price_plus_pickup_dropoff_fee": "Subtotal",

    "way_point_selection.pickup_location_and_address": "Pickup Location",
    "way_point_selection.dropoff_location_and_address": "Drop-off Location",
    "way_point_selection.pickup_locations_and_addresses": "Pickup Locations",
    "way_point_selection.dropoff_locations_and_addresses": "Drop-off Locations",
    "subtotal.seats_pickup_dropoff_amount_details" : "Subtotal Details",

    
    "small_car_details.seating_is_auto": "Seats for this trip will be automatically arranged.",
    "small_call_details.included_in_price" : "Included In The Price",
    "small_car_details.ride_far": "Ride Fare", 
    "small_car_details.standard_baggage_allowance": "Standard Baggage Allowance",
    "small_call_details.not_included_in_price" : "Not Included In The Price",
    "small_car_details.pick_up_service" : "Pickup/Drop-off Service",
    "small_car_details.pick_up_service_fee" : "Pickup/Drop-off Fee",
    "operator.seat_selectable_tip" : "Seat Selectable",
    "operator.pickup_dropoff_service_tip" : "Pickup/Drop-Off",
    "operator.pickup_service_only_tip" : "Pickup",
    "operator.dropoff_service_only_tip" : "Drop-Off",
    "operator.instant_confirmation":  "Instant confirmation",

    "common.seat_prices_chart" : "Seat Price Options",
    "common.see_seat_prices_chart" : "Click to See Seat Types",
    "common.price_per_seat" : "Price per seat",
    "common.back" : "Go Back",

    "common.small_car_trips": "Available Other Options (Ride Share)",
    "common.express_bus_trips": "Available Express Bus Options",    

    "common.home_address_pickup_locations": "Door-to-door Pickup Locations",
    "common.home_address_dropoff_locations": "Door-to-door Drop-off Locations",
    "common.gathering_points": "Gathering Points",
    "common.gathering_point": "Gathering Point",

    
     "common.home_address_pickup_location": "Door-to-door Pickup Location",
     "common.home_address_dropoff_location": "Door-to-door Drop-off Location",
    
    "common.pickup_dropoff_info_details": "We will contact you shortly with the details about pickup/drop-off service and service charges.",
    "common.pickup_dropoff_extra_fees_notice1": "If the pickup/drop-off service is available, you may need to pay an additional fee depending on your location.",
    "common.pickup_dropoff_extra_fees_notice2": "An estimated cost will be provided in advance.",
    "common.connection_failed_error_title": "Something went wrong.",
    "common.connection_failed_error_description": "Please check your internet connection and try again.",

    "trip_search.retry" : "Try Again",

    "seat_assignment_pending" : "Seat assignment will be carried out as soon as possible.",    
    "payment_success_and_seat_assignment_pending" : "Payment is successful. Seat assignment will be carried out as soon as possible.",

    "samll_car_ads_description" : "Door-to-door rides available.",    
    "samll_car_ads_tips" : "Small car, premium service",
    "view": "View",
    "seat_selection.price_level_warning_message": '%{operator} doesn\'t allow selecting different seat prices in one booking.',
    "seat_selection.price_level_warning_title": 'Cannot select seats with different prices',


};

let myMessages = {
    "title": "MMBusTicket",
    "lang.my": "မြန်မာ",

    "nav_title.express_bus_trips": "ကားကြီး ခရီးစဉ်များ",
    "nav_title.small_car_trips": "ကားလေး ခရီးစဉ်များ",
    "nav_title.search_trip": "ခရီးစဉ် ရှာရန်",
    "nav_title.select_seat": "ခုံရွေးရန်",
    "nav_title.select_pickup_dropoff": "ကြို/ပို့ နေရာ ရွေးရန်",
    "nav_title.make_payment": "ငွေပေးချေရန်",
    "nav_title.traveller_info": "ခရီးသည် အချက်အလက်",
    "nav_title.booking_info": "ဘိုကင်အချက်အလက်",
    "nav_title.terms_conditions": "စည်းကမ်းနှင့်သတ်မှတ်ချက်များ",

    "nav_title.already_paid": "ငွေပေးချေမှု",

    
    "departure": "ထွက်ခွာချိန်",
    "price": "​စျေးနှုန်း",
    "operators": "ကားလိုင်းများ",

    "day_bus": "နံနက်ကား",
    "night_bus": "ညကား",
    "afternoon_bus" : "နေ့ခင်းကား",
    "price_low_high": "​ဈေးအနည်းမှအများ",
    "price_high_low": "ဈေးအများမှအနည်း",

    "all_filter": "စိစစ်ရန်",
    "filter_title": "စိစစ်ခြင်း",
    "cancel": "မလုပ်​တော့ပါ",
    "apply": "အတည်ပြုရန်",

    "operator_photo": "ဓါတ်ပုံ",
    "operator_photos": "ဓါတ်ပုံများ",

    "location_from": "မှ",
    "location_to": "သို့",
    "departure_date": "ထွက်မည့်ရက်",
    "seat": "ခုံ",
    "seats": "ခုံ",
    "seat_number" : "ခုံနံပါတ် : ",
    "seat_numbers" : "ထိုင်ခုံ နံပါတ်",

    "about_operator": "ကားလိုင်းအကြောင်း",

    "tooltip": "ကားလိုင်းနှင့်အခြား",

    "tonight": "ယနေ့ည",
    "one": "၁",
    "top_location": "လူသွားအများဆုံးနေရာများ",
    "select_destination": "တည်နေရာကိုရွေးချယ်ပါ",
    "select_seats": "ခုံရွေးရန်",
    "location": "သွားမည့် မြို့ / နေရာ",
    "locations": "သွားမည့် မြို့ / နေရာ",
    "search": "ရှာရန်",
    "search_now": "ရှာရန်",
    "search_small_car": "ကားလေး ရှာမည်",
    "local": "မြန်မာနိုင်ငံသား",
    "foreigner": "နိုင်ငံခြားသား",
    "all_photos": "ပုံကြည့်ရန်",
    "photo": "ပုံ",
    "photos": "ပုံ",
    "prices": "ဈေးနှုန်း",
    "all_prices": "ဈေးနှုန်းအားလုံးကြည့်ရန်",
    "lowest_prices": "ဈေးနှုန်းအနိမ့်ဆုံးမှကြည့်ရန်",
    "highest_prices": "ဈေးနှုန်းအမြင့်ဆုံးမှကြည့်ရန်",
    "price_range": "ဈေးနှုန်းကန့်သတ်ရန်",
    "promotion": "လျှော့ဈေး",
    "select_price_range": "ဈေးနှုန်းကန့်သတ်ချက်ကို ရွေးချယ်ပါ",
    "select_price_order_type": "ဈေးနှုန်းစီရန် ရွေးချယ်ပါ",
    "from": "မှ",
    "check_out": "ဝယ်ယူမည်",
    "continue": "ဆက်သွားမည်",
    "read_more": "ဆက်ဖတ်ရန်",
    "read_less": "ပြန်ချုံ့ရန်",
    "details": "ရက်အလိုက်ကြည့်ရန်",
    "select": "ရွေးမည်",
    "view_booking_details": "ဝယ်ယူထားသောအခန်းများအသေးစိတ်ကြည့်ရန်",
    "name": "အမည်",
    "gender": "ကျား/မ",
    "male": "အမျိုးသား",
    "female": "အမျိုးသမီး",
    "mixed_group": "ကျား/မအဖွဲ့",
    "email": "အီးမေလ်း (email)",
    "phone_number": "ဆက်သွယ်ရန် ဖုန်းနံပါတ်",
    "nationality": "နိုင်ငံသား",
    "myanmar": "မြန်မာ",
    "myanmar_nationality": "မြန်မာနိုင်ငံသား",
    "special_request": "မှတ်ချက်",
    "submit": "တင်သွင်းမည်",
    "contect_header": "ဧည့်သည်အချက်အလက် ဖြည့်ရန်",
    "night": "ည",
    "cancellation_policy": "စည်းကမ်းချက်များ",
    "no_included": "မပါ",
    "included": "လုံး",
    "secure_checkout": "ဧည့်သည်အချက်အလက် အဆင့်",
    "sub_total": "အခန်းအတွက် ကျသင့်ငွေ",
    "convience_fee": "ငွေပေးချေစနစ် ဝန်ဆောင်ခ",
    "total": "စုစုပေါင်းကျသင့်ငွေ",
    "pay_now": "ငွေပေးမည်",
    "payment_summary": "ငွေပေးချေမှု အကျဉ်းချုပ်",
    "payment": "ငွေပေးချေမှု အဆင့်",
    "contact_information": "ဧည့်သည်အချက်အလက်",
    "edit": "ပြင်ရန်",
    "close": "ပိတ်ရန်",
    "gallery": "ဓာတ်ပုံများ",
    "cancel_information": "သင်ရွေးချယ်ထားသော အချက်အလက်များအား သင်ဖျက်သိမ်းရန် သေချာပါသလား ?",
    "delete_room": " အခန်းကို ပယ်ဖျက်ရန် သေချာပါသလား?",
    "warning": "သတိပေးချက်",
    "seat_not_availiable": "သင်ရွေးချယ်ထားသော ခုံမှာမရရှိနိုင်တော့ပါ။ အခြားခုံအား ပြောင်းလဲရွေးချယ်ပါ။",
    "failed_to_request_seat_order": "ဒီခရီးစဉ်ကို လက်ရှိအချိန်တွင် မရရှိနိုင်သေးပါ။ အခြားခရီးစဉ်တစ်ခုကို ရွေးချယ်ပါ။",
    "seat_will_lost": "သင်ရွေးချယ်ထားသော ထိုင်ခုံများအား ဆုံးရှုံးလိမ့်မည်။",
    "can't_change_seat_selection": "ထိုင်ခုံနေရာ ပြောင်းလဲ၍ မရတော့ပါ",
    "back_to_seat_selection_confirmation_title": "ခုံရွေးရန် သို့",
    "__back_to_seat_selection_confirmation_title": "နောက်သို့ ပြန်သွားမည်",
    "back_to_seat_selection_confirmation_description": "ခုံနေရာ ကြည့်ရန် ပြန်သွားမည်",
    "back_to_seat_selection_confirm_and_alert_description": "ရွေးချယ်ထားသော ကြို/ပို့ နေရာ အချက်အလက်များ ပျက်သွားမည်။ \n\n'ခုံရွေးရန်' သို့ပြန်သွားလိုပါသလား",
    "back_to_seat_selection": "ရွေးချယ်ထားသော ထိုင်ခုံနေရာ ပြန်ကြည့်လိုပါသလား။",
    "waypoint_selection_edit_confirm_message": "ကြို/ပို့ နေရာ ပြင်ရန် ပြန်သွားလိုပါသလား",
    "filled_data_will_lost": "ဖြည့်သွင်းထားသော အချက်လက်အား ဆုံးရှုံးလိမ့်မည်။",
    "restart_warning_title" : "ခရီးစဉ်ရှာရန် အစသို့",
    "restart_warning_message" : "ခရီးစဉ်ရှာရန် အစသို့ပြန်သွားမည်။",
    "nrc_card_is_required": "နိုင်ငံသားစိစစ်ရေးကတ် ယူဆောင်လာရန် လိုအပ်ပါသည်။",
    "seat_selection_allowed": "စိတ်ကြိုက်ခုံရွေး",

    "search_form.type_express_bus": "ကားကြီး",
    "search_form.type_small_car": "ကားလေး",
    "search_form.promotion": "ပရိုမိုးရှင်း",

    "feedback_driver_discipline": "စည်းကမ်းရှိစွာမောင်းနှင်မှု",
    "feedback_driver_comfort": "ထိုင်ခုံအဆင်ပြေမှု",
    "feedback_driver_cleanliness": "ယာဉ်သန့်ရှင်းမှု",
    "feedback_driver_service": "အကူအညီ/၀န်ဆောင်မှု",
    "feedback_driver_punctuality": "အချိန်မှန်မှု",
    "message.no_express_trip_available": "ကားကြီး ခရီးစဉ် မတွေ့ရှိပါ။",
    "message.no_small_car_trip_available": "ကားလေး ခရီးစဉ် မတွေ့ရှိပါ။",
    "message.change_date_or_route": "ရက်စွဲ သို့မဟုတ် လမ်းကြောင်းကို ပြောင်းပြီး ရှာဖွေကြည့်ပါ။",

    "seat_selection_is_not_allowed": "ထိုင်ခုံရွေးချယ်မှုသည် ဤခရီးစဉ်အတွက် အလိုအလျောက်ဖြစ်ပြီး စိတ်ကြိုက်ရွေးချယ်၍မရပါ။",
    "seat_selection_is_auto_after_payment": "ဤကားလိုင်းသည် စိတ်ကြိုက်ခုံရွေးစနစ်မဟုတ်ပဲ ငွေပေးချေမှု အတည်ပြုပြီးနောက် ထိုင်ခုံများကို သတ်မှတ်ပေးပါမည်။",

    "review.title": "မှန်ကန်မှုအတည်ပြုပါ",
    "review.update_traveller_info": "ပြင်မည်",
    "review.continue": "ဆက်လက် လုပ်ဆောင်မည်",
    "review.ensure_info_correctness": "ဆက်လက် မလုပ်ဆောင်မီ အချက်အလက်များ မှန်ကန်စေရန် သေချာစွာစစ်ဆေးပါ။",

    "review.total_due": "စုစုပေါင်း (သင့်ငွေ)",
    "review.pay_now": "ငွေပေးချေမည်",
    "review.pay_before_time": "လက်မှတ်ရရန် %{time} မတိုင်မီ ငွေပေးချေပါ။",
    "review.unit_ticket_price": "တစ်စောင်တန်ဖိုး",
    "review.ticket_price": "လက်မှတ်တန်ဖိုးပေါင်း",
    "review.discount": "လျှော့စျေး",
    "review.convenience_fee": "Convenience Fee",
    "review.tax": "အခွန်",
    "review.use_promo_code": "ပရိုမိုကုဒ်ရှိလျှင်သုံးရန်",
    "review.apply_promo_code": "အသုံးပြုမည်",
    "review.applying_promo_code": "လုပ်ဆောင်နေသည်",
    "review.applied_promo_code": "အသုံးပြုထားသောကုဒ်",    
    "review.remove_promo_code": "ပယ်ဖျက်ပါ",
    "review.invalid_promo_code": "ဤပရိုမိုကုဒ်ကို သုံး၍မရပါ။",

    //"review.traveller_info": "အချက်အလက်များ ပြန်လည်စစ်ဆေးခြင်း",
    "review.traveller_info": "ခရီးသည် အချက်အလက်",

    "operator.name": "ကားလိုင်း",
    "operator.photos_unavailable": "ဤကားလိုင်းအတွက် ဓာတ်ပုံများမရှိပါ။",

    "trip.operator_notices": "%{name}မှ အသိပေးချက်",

    "trip.morning": "နံနက်",
    "trip.afternoon": "နေ့လည်",
    "trip.evening": "ညနေ",

    "trip.route": "ကားသွားမည့် လမ်းကြောင်း",
    "trip.route_details": "လမ်းကြောင်း အပြည့်အစုံ",
    "trip.operator": "ကားလိုင်း",
    "trip.bus_type": "ကားအမျိုးအစား",
    "trip.departure_gate": "ထွက်ခွာမည့်ဂိတ်",
    "trip.departure_time": "ထွက်ခွာချိန်",
    "trip.arrival_time": "ဆိုက်ရောက်ချိန်",
    "trip.arrival_gate" : "ဆိုက်ရောက်မည့်ဂိတ်",
    "trip.eta_duration": "ခန့်မှန်းကြာချိန်",
    "trip.duration" : " ကြာချိန်",
    "trip.eta": "ခန့်မှန်း",
    "trip.estimated": "ခန့်မှန်း",
    "trip.notice_estimated_arrival" : "ဆိုက်ရောက်ချိန်မှာ ခန့်မှန်းခြေသာဖြစ်ပြီး အကြောင်းကြောင်းကြောင့် ပြောင်းလဲနိုင်ပါသည်။",

    "trip.starts_at": "%{time} (ဂိတ်စ)", 
    "trip.departs_at": "%{time} (ထွက်ချိန်)", 
    "trip.arrives_at": "%{time} (ခန့်မှန်း)", 

    "trip.starts": "(ဂိတ်စ)", 
    "trip.departs": "(ထွက်ချိန်)", 
    "trip.arrives": "(ခန့်မှန်း)", 
    
    "trip_group.departs": "ထွက်ချိန်", 

    "seat_selection.seat_unit_singular": "ခုံ",
    "seat_selection.seat_unit_plural": "ခုံ",
    "seat_selection.seat_count": "ထိုင်ခုံ အရေတွက်",
    "seat_selection.seat_numbers": "ခုံနံပါတ်",
    "seat_selection.submit": "ဆက်သွားမည်",
    "seat_selection.submitting": "လုပ်ဆောင်နေဆဲ",

    "traveller_form.name": "ခရီးသည်အမည်",
    "traveller_form.gender": "ကျား/မ",
    "traveller_form.phone": "ဖုန်းနံပါတ်",
    "traveller_form.phone_instruction": "ကားလက်မှတ် အတည်ပြုချက် SMS ဤဖုန်းနံပါတ်သို့ ပေးပို့ပါမည်။",
    "traveller_form.email": "Email",
    "traveller_form.email_instruction": "ဖြည့်သွင်းထားပါက ကားလက်မှတ် အတည်ပြုချက် Email ရရှိပါမည်။",
    "traveller_form.special_request": "မှတ်ချက် (Special Request)",
    "traveller_form.gender_option_male": "အမျိုးသား",
    "traveller_form.gender_option_female": "အမျိုးသမီး",
    "traveller_form.gender_option_mixed_group": "ကျား/မအဖွဲ့",
    "traveller_form.next_step_instruction": "နောက်တစ်ဆင့်တွင် ငွေပေးချေပြီးနောက် လက်မှတ်ရရှိမည် ဖြစ်သည်။",

    "traveller_form.submit": "ဆက်သွားမည်",
    "traveller_form.submitting": "လုပ်ဆောင်နေဆဲ",

    "traveller.name": "ခရီးသည်အမည်",
    "traveller.phone": "ဖုန်းနံပါတ်",
    "traveller.email": "Email",
    "traveller.no_fill" : "မဖြည့်ထားပါ",
    "traveller.special_request": "မှတ်ချက် (Special Request)",

    "booking.subtotal_amount": "လက်မှတ်တန်ဖိုးပေါင်း",
    "booking.ticket_price_subtotal": "ထိုင်ခုံ တန်ဖိုးပေါင်း",
    "booking.ticket_price_pickup_dropoff_subtotal": "ထိုင်ခုံ+ကြိုပို့ တန်ဖိုးပေါင်း",
    "booking.tax_amount": "ကျသင့်အခွန်",
    "booking.discount_amount": "လျှော့စျေးပမာဏ",
    "booking.total_payment_amount": "စုစုပေါင်း (သင့်ငွေ)",

    "booking.purchased_date": 'ဝယ်သည့်ရက်',

    "section.trip_summary_title": "ခရီးစဉ် အကျဉ်းချုပ်",
    "section.seat_selection_title": "ထိုင်ခုံရွေးချယ်မှု",
    "section.traveller_info_title": "ခရီးသည် အချက်အလက်",
    "section.due_amount_details": "ကျသင့်ငွေ အသေးစိတ်",
    "section.payment_details" : "ငွေပေးချေမှု အသေးစိတ်",
    
    "duration_hour": "နာရီ",
    "duration_minute": "မိနစ်",
    
    "booking_confirmation_awaiting.title" : "အတည်ပြုအဆင့်",
    "booking_confirmation_awaiting.message_to_reload": "စောင့်ဆိုင်းမှု ကြာနေပါက အောက်ပါခလုပ်ကို နှိပ်ပါ",

    "confirmation.payment_successful": "ငွေပေးချေမှု အောင်မြင်ပါသည်။",
    "confirmation.confirming_booking": "ဘိုကင် အတည်ပြုနေပါသည် ...",
    "confirmation.please_wait": "ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပေးပါ။",

    "nav_menu.home": "ပင်မစာမျက်နှာ",
    "nav_menu.my_bookings": "ဝယ်ယူမှုမှတ်တမ်း",
    "nav_menu.find_my_booking": "ဘိုကင်ရှာရန်",
    "nav_menu.about_us": "ကျွန်ုပ်တို့၏အကြောင်း",
    "nav_menu.terms_conditions": "စည်းကမ်းနှင့်သတ်မှတ်ချက်များ",
    "nav_menu.privacy_policy": "ကိုယ်ရေးအချက်အလက်မူဝါဒ",
    "nav_menu.faq": "မေးလေ့ရှိသောမေးခွန်းများ",
    "nav_menu.contact": "ဆက်သွယ်ရန်",
    "nav_menu.help": "အကူအညီ",

    "estimated" : "(ခန့်မှန်းခြေ)",

    "proceed_to_payment": "ငွေပေးချေရန်သို့",

    "confirmation_title.back_to_initial_page": "ခရီးစဉ်ရှာရန် အစသို့",
    "confirmation_msg.back_to_initial_page": "ဘိုကင်တင်ခြင်း အတွက် ကျေးဇူးတင်ပါသည်။ ခရီးစဉ်ရှာရန် အစသို့ပြန်သွားမည်",
    "confirmation_msg.back_to_home" : "အစသို့ ပြန်သွားမည်",
    "search.choose_source_location" : "စထွက်မည့်နေရာ ရွေးချယ်ပါ",
    "search.choose_destination_location" : "သွားမည့်နေရာ ရွေးချယ်ပါ",
    "search.confirm_cancellation": "အစသို့ပြန်လည်ရောက်ရှိမည်ဖြစ်ပြီး လက်ရှိရှာဖွေမှုကို ပယ်ဖျက်ပါမည်။",

    "booking_confirmation.booking_success_msg": "ဘိုကင်တင်ခြင်း အောင်မြင်ပါသည်",
    "booking_confirmation.send_confirmation_info": "အတည်ပြုချက်ကို သင့်ထည့်သွင်းထားသော အီးမေးလ် သို့မဟုတ် SMSသို့ ပေးပို့ပေးပါမည်။ ",
    "booking_details.booked_at" : "ဘိုကင်တင်သည့်ရက်",    
   
    "review_info.confirmation_header_message" : "ခရီးစဉ်နှင့် ခရီးသည်အချက်အလက်များ သေချာရန် ပြန်စစ်ဆေးပါ",
    "review_info.confirmation_checkbox_message": "ခရီးစဉ်နှင့် ခရီးသည်အချက်အလက်များ မှန်ကန်ပါသည်။",
    
    "my_bookings.no_booking_message_title" : "ဘိုကင်တင်ထားခြင်း မရှိသေးပါ။",
    "my_bookings.no_booking_message_description" : "သွားချင်တဲ့ခရီးကို ဘိုကင်တင်ပြီး အမှတ်တရတွေဖန်တီးလိုက်ပါ။",
    "my_bookings.booking_details": "ဘိုကင်အပြည့်အစုံ",
    "my_bookings.booked_at_time": "ဘိုကင်တင်သည့်အချိန်: %{time}",
    "my_bookings.processint_status": "အတည်ပြုနေဆဲ",
    "my_bookings.processing_booking_date": "ဘိုကင်တင်သည့်ရက်",
    "my_booking_details.processing_title" : "ရွေးချယ်ထားသော ထိုင်ခုံနေရာရရှိနိုင်ရန် အမြန်ဆုံးဆောင်ရွက်နေပါသည်။",
    
    "need_help" : "အကူအညီလိုလျှင်",
    "contact.call_hotline": "အကူအညီ (Customer Support)", 

    "validity.traveller_name": "ခရီးသည်အမည် လိုအပ်ပါသည်။",
    "validity.required_phone_number": "ဖုန်းနံပါတ် လိုအပ်ပါသည်။",
    "validity.invalid_phone_number": "ဖုန်းနံပါတ်သည် '09' ဖြင့်စရမည်ဖြစ်ပြီး ဂဏန်း ၉ လုံး မှ ၁၁ လုံး ပါရှိရမည်။",
    "validity.email": "ဖြည့်သွင်းထားသော အီးမေးလ်လိပ်စာသည် မမှန်ကန်ပါ။",
    "validity.required_selection" : "တစ်ခုကို ရွေးချယ်ရပါမည်။",

    "payment.error_title": "ငွေပေးချေမှု မအောင်မြင်ပါ။",
    "payment.error_generic_advice": "ထပ်မံကြိုးစားနိုင်ပါသည်။ သို့သော် အင်တာနက်ချိတ်ဆက်မှုကိုစစ်ဆေးပါ။ ထိုင်ခုံရွေးချယ်မှုကို 10 မိနစ်အတွင်းကပြုလုပ်ခဲ့ရန် လိုအပ်ပါသည်။",


    "summary" : "Summary",
    "subtotal" : "ထိုင်ခုံ တန်ဖိုးပေါင်း",
    "fees" : "ဝန်ဆောင်ခ",
    "discount": "လျှော့စျေး",
    "net_to_pay": "ပေးရန်ငွေ",
    "terms" : "စည်းကမ်း သတ်မှတ်ချက်များ",
    //"agree_to_terms": "ငွေပေးချေမှု ဆက်လက်လုပ်ဆောင်ခြင်းဖြင့် သင်သည် ",
    "agree_to_terms": "ဆက်လက်လုပ်ဆောင်ခြင်းဖြင့် ",
    "terms_link": "စည်းကမ်းသတ်မှတ်ချက်များ",
    "agree_to_terms_end": "ကို သဘောတူပြီး ဖြစ်ပါသည်။",
    "proceed_to_pay" : "ငွေပေးချေမည်",
    "show_other_methods" : "ငွေပေးချေမှုနည်းလမ်း ပြန်ရွေးရန်",
    "title_payment_method" : "ငွေပေးချေမှုနည်းလမ်း",
    "to_reselect" : "ပြန်ရွေးရန်",
    "promo_code": "ပရိုမိုကုဒ်",
    "apply_code": "ထည့်မည်",
    "apply_promo_code": "ပရိုမိုကုဒ်ထည့်မည်",
    "message.required_promo_code": "ပရိုမိုကုဒ်ထည့်ပါ",
    "message.invalid_promo_code": "ပရိုမိုကုဒ် မှားနေပါသည်",

    "message_title.payment_completed": "ငွေပေးချေပြီး ဖြစ်ပါသည်",
    "message_description.payment_completed": "ဤ booking အတွက် ‌ငွေပေးချေပြီးဖြစ်၍ ထပ်မံငွေပေးချေ၍ မရပါ။",
    "message.help_info": "အကူအညီ လိုအပ်ပါက Customer Support ကို ဆက်သွယ်ပါ။",

    "trip.multiple_price" : "ခုံစျေးအမျိုးမျိုး",
    "seat_selection.select_one_seat" : "ထိုင်ခုံ 1ခုံ ရွေးချယ်ပါ",
    "seat_selection.select_n_seats" : "ထိုင်ခုံ %{numOfSeats} ခုံ ရွေးချယ်ပါ",
    "price_per_seat": "ထိုင်ခုံ တစ်ခုံတန်ဖိုး",
    "total_seat_price": "ထိုင်ခုံ တန်ဖိုးပေါင်း",

    "total_pickup_fee_": "လာကြိုခ တန်ဖိုးပေါင်း ",
    "total_dropoff_fee_": "ပို့ဆောင်ခ  တန်ဖိုးပေါင်း ",
    
    "total_pickup_fee": "လာကြိုခပေါင်း",
    "total_dropoff_fee": "ပို့ဆောင်ခပေါင်း",
    "total_seats_price_plus_pickup_dropoff_fee": "ထိုင်ခုံ+ကြိုပို့ တန်ဖိုးပေါင်း",

    "way_point_selection.number_of_travellers": "ခရီးသည်အရေအတွက်",
    "way_point_selection.address": "လိပ်စာ",
    "way_point_selection.pickup_location": "လာကြိုရမည့် နေရာ",
    "way_point_selection.dropoff_location": "ပို့ဆောင်ရမည့် နေရာ",    
    "way_point_selection.choose_pickup_title": "လာကြိုရမည့် နေရာ ရွေးရန်",
    "way_point_selection.choose_dropoff_title": "ပို့ဆောင်ရမည့် နေရာ ရွေးရန်",
    "way_point_selection.choose_pickup_location": "လာကြိုရမည့် နေရာ ရွေးပါ",
    "way_point_selection.choose_dropoff_location": "ပို့ဆောင်ရမည့် နေရာ ရွေးပါ",    
    "way_point_selection.pickup_location_details": "လာကြိုရမည့် လိပ်စာအသေးစိတ်",
    "way_point_selection.dropoff_location_details": "ပို့ဆောင်ရမည့် လိပ်စာအသေးစိတ်", 
    "way_point_selection.remove": "ဖယ်ရှားရန်", 
    "way_point_selection.change": "ပြင်ဆင်ရန်",     
    "way_point_selection.select_for_remaining_travellers": "ကျန်ခရီးသည်  (%{numOfTravellers}) ဦးအတွက် ရွေးပါ", 
    "way_point_selection.number_of_travellers_from_pickup_location": "ဤလိပ်စာမှ ကြိုရမည့် ခရီးသည်အရေအတွက်",
    "way_point_selection.number_of_travellers_to_dropoff_location": "ဤလိပ်စာသို့ ပို့ရမည့် ခရီးသည်အရေအတွက်",
    
    "way_point_selection.number_of_travellers_from_fixpoint": "ဤစုရပ်နေရာမှ လိုက်မည့် ခရီးသည်အရေအတွက်",
    "way_point_selection.number_of_travellers_to_fixpoint": "ဤစုရပ်နေရာသို့ ပို့ရမည့် ခရီးသည်အရေအတွက်",

    "common.gathering_point_description": "ဤစုရပ်နေရာအတွက် ဖော်ပြချက်/ညွှန်ကြားချက်များ",

    "way_point_selection.all_travellers": "ခရီးသည်အားလုံး",

    "way_point_selection.single_pickup_location_selected_for_all": "အားလုံးအတွက် လာကြိုရမည့်နေရာ တစ်နေရာတည်း ရွေးထားပါသည်။",
    "way_point_selection.single_dropoff_location_selected_for_all": "အားလုံးအတွက် ပို့ဆောင်ရမည့်နေရာ တစ်နေရာတည်း ရွေးထားပါသည်။",
    
    "no_of_travellers" : "ခရီးသည်အရေအတွက်",
    "no_of_seats" : "ထိုင်ခုံ အရေအတွက်",

    "small_car.non_direct_booking_warning": "ရွေးချယ်ထားသော ထိုင်ခုံနေရာများကို ဦးစားပေး စီစဉ်ပေးပါမည်။",
    
    "way_point_selection.one_person": "1 ယောက်",
    "way_point_selection.no_of_traveller_unit": "ယောက်",
    "way_point_selection.no_of_travellers_unit": "ယောက်",
    "way_point_selection.pickup_location_and_address": "လာကြိုရမည့် နေရာ",
    "way_point_selection.dropoff_location_and_address": "ပို့ဆောင်ရမည့် နေရာ",
    "way_point_selection.pickup_locations_and_addresses": "လာကြိုရမည့် နေရာများ",
    "way_point_selection.dropoff_locations_and_addresses": "ပို့ဆောင်ရမည့် နေရာများ",
    "subtotal.seats_pickup_dropoff_amount_details" : "ထိုင်ခုံ+ကြိုပို့ တန်ဖိုးအသေးစိတ်",

    "small_car_details.seating_is_auto": "ခရီးစဉ်၏ ထိုင်ခုံနေရာများကို အလိုအလျောက် စီစဉ်ပေးပါမည်။",
    "small_call_details.included_in_price" : "ဈေးနှုန်းအတွင်း ပါဝင်သည်များ",
    "small_car_details.ride_far": "ကားခ", 
    "small_car_details.standard_baggage_allowance": "ပုံမှန်အရွယ် ခရီးသွားအိတ်/ပစ္စည်းများ သယ်ယူနိုင်",
    "small_call_details.not_included_in_price" : "ဈေးနှုန်းအတွင်း မပါဝင်သည်များ",
    "small_car_details.pick_up_service" : "အိမ်ရောက်ကြိုပို့ဝန်ဆောင်မှု",
    "small_car_details.pick_up_service_fee" : "အိမ်ရောက်ကြိုပို့ ဝန်ဆောင်ခ",
    "operator.seat_selectable_tip" : "ခုံရွေး",
    "operator.pickup_dropoff_service_tip" : "ကြိုပို့",
    "operator.pickup_service_only_tip" : "ကြို",
    "operator.dropoff_service_only_tip" : "ပို့",
    "operator.instant_confirmation":  "ချက်ချင်းလက်မှတ်ရ",

    
    "common.seat_prices_chart" : "ခုံစျေးနှုန်း အမျိုးအစားများ",
    "common.see_seat_prices_chart" : "ခုံအမျိုးအစားများ ကြည့်ရန်",
    "common.see_seat_prices_chart_" : "ခုံအမျိုးအစားနှင့် ဈေးနှုန်းများ ကြည့်ရန်",
    "common.price_per_seat" : "တစ်ခုံဈေးနှုန်း",
    "common.per_seat" : "1 ခုံ",

    "__common.express_bus_trips": "ကားကြီး ခရီးစဉ်များ ရှိပါသည်",
    "__common.small_car_trips": "ကားလေး ခရီးစဉ်များ ရှိပါသည်",

    
    "common.home_address_pickup_locations": "အိမ်အရောက် လာကြိုပေးမည့် နေရာများ",
    "common.home_address_dropoff_locations": "အိမ်အရောက် ပို့ဆောင်ပေးမည့် နေရာများ",
    "common.gathering_points": "စုရပ် နေရာများ",
    "common.gathering_point": "စုရပ်နေရာ",
    "common.back": "နောက်သို့",

    "common.home_address_pickup_location": "အိမ်အရောက် လာကြိုပေးမည့် နေရာ",
    "common.home_address_dropoff_location": "အိမ်အရောက် ပို့ဆောင်ပေးမည့် နေရာ",

    "common.express_bus_trips": "အခြားရွေးချယ်စရာ - ကားကြီး ခရီးစဉ်များ",
    "common.small_car_trips": "အခြားရွေးချယ်စရာ - ကားလေး ခရီးစဉ်များ",

    
    "common.pickup_dropoff_extra_fees_notice1": "ကြို/ပို့ ဝန်ဆောင်မှု ရှိပါက လမ်းကြောင်းပေါ်မူတည်၍ အပိုငွေ ထပ်မံပေးဆောင်ရပါမည်။",
    "common.pickup_dropoff_extra_fees_notice2": "အပိုငွေ ခန့်မှန်းကုန်ကျစရိတ်အား ကြိုတင်အကြောင်းကြားပေးပါမည်။",
 
    "common.connection_failed_error_title": "ခရီးစဉ် ရှာမရပါ။",
    "common.connection_failed_error_description": "အင်တာနက် ချိတ်ဆက်မှုကို စစ်ဆေးပြီး ထပ်မံ ကြိုးစားကြည့်ပါ။",
    
    "trip_search.retry" : "ပြန်ရှာကြည့်မည်",
    
    "common.pickup_dropoff_info_details": "အိမ်အရောက် ကြိုပို့ ဝန်ဆောင်မှု/ဝန်ဆောင်ခ နှင့် ပတ်သတ်၍ အသေးစိတ် ဆက်သွယ်ပေးပါမည်။",


    "seat_assignment_pending" : "ထိုင်ခုံနေရာသတ်မှတ်ခြင်းကို အမြန်ဆုံးဆောင်ရွက်နေပါသည်။",    
    "payment_success_and_seat_assignment_pending" : "ငွေပေးချေမှု အောင်မြင်ပါသည်။ ထိုင်ခုံနေရာသတ်မှတ်ခြင်းကို အမြန်ဆုံးဆောင်ရွက်နေပါသည်။",
    
    "samll_car_ads_description" : "အရောက်ကြို/ပို့ ကားလေး ခရီးစဉ် ရပါပြီ", 
    "samll_car_ads_tips" : "ကားလေး ၊ ပရီမီယံဝန်ဆောင်မှု",
    "view": "ကြည့်မည်",
    
    "seat_selection.price_level_warning_message": '%{operator}ယာဉ်လိုင်းတွင် ဈေးနှုန်းမတူသော ထိုင်ခုံများကို အတူတကွ ဝယ်ယူ၍ မရပါ။',
    "seat_selection.price_level_warning_title": 'စျေးနှုန်းတူသော ထိုင်ခုံများကို ရွေးချယ်ပါ',

}

export class MessageManager implements MessageProvider{
    currentLang:string;
    polyglot:Polyglot;

    constructor(defaultLang) {
        this.currentLang = defaultLang;
        //console.log("Window.LocalStorage : ", window.localStorage)
        if(window.localStorage) {
           let storedLang = window.localStorage.getItem('lang');
           if(storedLang) {
               if(storedLang.toLowerCase().includes("en")){
                    this.currentLang = "en";
               }else if(storedLang.toLowerCase().includes("my")){
                    this.currentLang = "my";
               }
           }
        }  

        this.polyglot = new Polyglot();
        this.polyglot.extend({
            "en": enMessages,
            "my": myMessages
        });
    }

    setCurrentLang(lang) {
        this.currentLang = lang;
        if(window.localStorage) {
            window.localStorage.setItem('lang', lang);
        }        
    }

    getCurrentLang() {
        return this.currentLang;
    }

    private getByLang(key:string, lang:string, params?:any) {
        let langKey = lang + "." + key;
        if(params) {
            return this.polyglot.t(langKey, params);
        } else {
            return this.polyglot.t(langKey);
        }
    }

    get(key:string, params?:any, lang?:string) {
        
        /*if(lang) {
            if(params) {
                return this.getByLang(key, lang, params);
            } else {
                return this.getByLang(key, lang);
            }
        } else {
            return this.getByLang(key, this.currentLang);
        }*/

        let effectiveLang = this.currentLang;
        if(lang) {
            effectiveLang = lang;
        }

        if(params) {
            return this.getByLang(key, effectiveLang, params);
        } else {
            return this.getByLang(key, effectiveLang);
        }
        
    }
}
